<template>
  <div>
    <h1>Registrar roles</h1>
    <a-form :form="form" @submit.prevent="handleSubmit">
      <a-form-item label="Nombre del rol administrador">
        <a-input
          placeholder="Nombre del rol administrador"
          v-model="$v.roleName.$model"
        />
        <small class="text-danger" v-if="!$v.roleName.required">Campo requerido. No debe estar vacío.</small>
        <small class="text-danger" v-if="!validateRegisteredRole($v.roleName.$model)">Ya existe un rol con este nombre</small>
      </a-form-item>
      <!--
      <b-form-checkbox-group
        id="checkbox-group-2"
        v-model="selected"
         @change="selectedObjectUpdate"
        name="flavour-2">
        <b-table
          show-empty
          stacked="md"
          :items="items"
          :current-page="currentPage"
          :per-page="perPage"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          empty-text="No existen registros por mostrar"
        >
        <template v-slot:cell(title)="row">
          <b-form-checkbox :value="row.item.title">{{ row.item.title }}</b-form-checkbox>
        </template>
        </b-table>
      </b-form-checkbox-group>-->
      <b-table
          show-empty
          stacked="md"
          :items="menu"
          :current-page="currentPage"
          :per-page="perPage"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          empty-text="No existen registros por mostrar"
          emptyFilteredText="No existen registros por mostrar"
        >
          <template v-slot:cell(acciones)="row">
            <b-button size="sm" @click="row.toggleDetails" class="mr-2">
              {{ row.detailsShowing ? 'Cerrar' : 'Ver'}} detalles
            </b-button>
          </template>
          <template #row-details="row">
            <b-form-checkbox-group
              id="checkbox-group-2"
              v-model="selected[row.item.title]"
              @change="selectedObjectUpdate"
              name="flavour-2">
              <b-table
                :items="row.item.children"
                small
                borderless
                :fields="[{ key: 'title', label:'Sub módulo' }]"
                >
                <template v-slot:cell(title)="row">
                  <b-form-checkbox :value="row.item.title">{{ row.item.title }}</b-form-checkbox>
                </template>
              </b-table>
            </b-form-checkbox-group>
          </template>
        <!--
        <template v-slot:cell(title)="row">
          <b-form-checkbox :value="row.item.title">{{ row.item.title }}</b-form-checkbox>
        </template>-->
      </b-table>
      <b-row sm="auto"  md="auto">
        <b-button
          variant="success"
          block
          @click="registerRole"
          :disabled="!(validateRegisteredRole($v.roleName.$model) && !$v.$invalid)"
          v-if="this.clicked === 0"
          >Registrar
        </b-button>
        <b-button class="mt-2" variant="outline-gray" block  v-else-if="this.clicked === 1">Cargando...</b-button>
        <b-button class="mt-2" variant="outline-gray" block  v-else-if="this.clicked === 2">Se a registrado exitosamente</b-button>
        <b-button class="mt-2" variant="outline-danger" block  v-else-if="this.clicked === 3">Ha ocurrido un error</b-button>
      </b-row>
    </a-form>
  </div>
</template>
<script>
import { getMenuData } from '../../../../services/menu/index.js'
import { required /* decimal */ } from 'vuelidate/lib/validators'
import * as firebase from 'firebase/app'
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
const CREATE_ROLE = gql`
  mutation createRole($name: String){
    createRole(role: { name: $name }){
      name
    }
  }
`
const QUERY_ALL_ROLES = gql`
  query getAllRoles{
    getAllRoles{
      id
      name
    }
  }
`
export default {
  data() {
    return {
      roleName: '',
      form: this.$form.createForm(this),
      selected: {},
      items: [],
      menu: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      fields: [
        { key: 'title', label: 'Módulo' },
        'acciones',
      ],
      registeredRoles: {},
      clicked: 0,
    }
  },
  apollo: {
    getAllRoles: {
      query: QUERY_ALL_ROLES,
      result({ data }) {
        data.getAllRoles.forEach(role => {
          this.registeredRoles[role.name] = 1
        })
        // console.log(this.registeredRoles)
      },
      error(err) {
        console.log(err)
      },
      context: headers(),
    },
  },
  mounted() {
    getMenuData.forEach(item => {
      if (item.category) {
        this.items.push(item)
      } else {
        this.menu.push(item)
      }
    })
    // console.log(getMenuData)
    // console.log(this.menu)
  },
  methods: {
    validateRegisteredRole(role) {
      if (this.registeredRoles[role.trim()]) {
        return false
      } else {
        return true
      }
    },
    selectedObjectUpdate() {
      // console.log(this.selected)
    },
    registerRole() {
      // console.log(this.selected)
      this.clicked = 1
      this.$apollo.mutate({
        mutation: CREATE_ROLE,
        variables: {
          name: this.roleName.trim(),
        },
        context: headers(),
      })
        .then(data => {
          firebase.firestore().collection('roles').doc(this.roleName).set(this.selected)
            .then(result => {
              this.clicked = 2
              this.$router.push('/admin/roles')
            })
            .catch(err => {
              this.clicked = 3
              console.log(err)
            })
        })
        .catch(err => {
          this.clicked = 3
          console.log(err)
        })
      // console.log(this.selected)
      // console.log(this.roleName)
    },
  },
  validations: {
    roleName: { required },
  },
}
</script>
<style>
</style>
